const additionalText =
	'При покупке товаров Лемана\u00A0ПРО вы можете сразу заказать установку от\u00A0профессиональных и\u00A0проверенных мастеров';

export const MainInfoTexts = {
	catalogue: {
		title: 'Установка товаров Лемана ПРО и\u00A0ремонтные работы',
		basePhotoUrl: `/PKpalwvxsEWcT4KQ-614yQ/services-platform-landing-main-photo`,
		additionalText,
	},
};
